<template>
    <div>
      <hp5-background>
        <hp5-page-content-container>
          <div id="landing-page-main-container">
            <hp5-spacing-vertical xs="lg" sm="lg" md="lg" lg="lg" />
            <div>
              <div id="main-heading">
                <hp5-heading tag-selection="h1" size-selection="xl">Find doctors or clinics</hp5-heading>
              </div>
                <div id="plan-name" v-if="plan">
                    <hp5-spacing-vertical xs="sm" sm="sm" md="sm" lg="sm" />
                    <hp5-semantic size-selection="sm"><hp5-heading tag-selection="h2" size-selection="md">You're searching the {{ plan.name }} network</hp5-heading></hp5-semantic>
                </div>
              <hp5-spacing-vertical xs="sm" sm="sm" md="sm" lg="sm" />
  
              <div>
                <hp5-container type="icon-card-horizontal" columns="2">
                  <div v-if="!showDentalOnly">
                    <hp5-icon-card-horizontal
                      heading-tag-selection="p"
                      icon-name="brand-doctor-3"
                      heading-text="Doctors & medical practitioners"
                      @click="changeView('doctor')"
                    />
                    <hp5-spacing-vertical xs="sm" sm="sm" md="sm" lg="sm" />
                  </div>
                  <div v-if="!showDentalOnly">
                    <hp5-icon-card-horizontal
                      heading-tag-selection="p"
                      icon-name="brand-stethoscope"
                      heading-text="Medical clinics"
                      @click="changeView('medical')"
                    />
                    <hp5-spacing-vertical xs="sm" sm="sm" md="sm" lg="sm" />
                  </div>
                  <div v-if="!showDentalOnly">
                    <hp5-icon-card-horizontal
                      heading-tag-selection="p"
                      icon-name="brand-urgent-care"
                      heading-text="Hospitals"
                      @click="changeView('hospital:1')"
                    />
                    <hp5-spacing-vertical xs="sm" sm="sm" md="sm" lg="sm" />
                  </div>
                  <div v-if="!showDentalOnly">
                    <hp5-icon-card-horizontal
                      heading-tag-selection="p"
                      icon-name="brand-care-providers-1"
                      heading-text="Skilled nursing facilities"
                      @click="changeView('hospital:3')"
                    />
                    <hp5-spacing-vertical xs="sm" sm="sm" md="sm" lg="sm" />
                  </div>
                  <div v-if="showCompareCosts">
                    <hp5-icon-card-horizontal
                      heading-tag-selection="p"
                      icon-name="brand-money"
                      link-href="/fcp/compare-costs/"
                      heading-text="Compare costs"
                    />
                    <hp5-spacing-vertical xs="sm" sm="sm" md="sm" lg="sm" />
                  </div>
                  <div v-if="!showMedicalOnly">
                    <hp5-icon-card-horizontal
                      heading-tag-selection="p"
                      icon-name="brand-business-man"
                      heading-text="Dentists & dental practitioners"
                      @click="changeView('dentist')"
                    />
                    <hp5-spacing-vertical xs="sm" sm="sm" md="sm" lg="sm" />
                  </div>
                  <div v-if="!showMedicalOnly">
                    <hp5-icon-card-horizontal
                      heading-tag-selection="p"
                      icon-name="brand-tooth"
                      heading-text="Dental clinics"
                      @click="changeView('dental')"
                    />
                    <hp5-spacing-vertical xs="sm" sm="sm" md="sm" lg="sm" />
                  </div>
                  <div v-if="!showDentalOnly">
                    <hp5-icon-card-horizontal
                      heading-tag-selection="p"
                      icon-name="brand-bandaid"
                      heading-text="Urgent care"
                      @click="changeView('urgent')"
                    />
                    <hp5-spacing-vertical xs="sm" sm="sm" md="sm" lg="sm" />
                  </div>
                  <div v-if="!showDentalOnly">
                    <hp5-icon-card-horizontal
                      heading-tag-selection="p"
                      icon-name="brand-brain-1"
                      heading-text="Specialty care"
                      @click="changeView('hospital')"
                    />
                    <hp5-spacing-vertical xs="sm" sm="sm" md="sm" lg="sm" />
                  </div>
                  <div v-if="!showDentalOnly">
                    <hp5-icon-card-horizontal
                      heading-tag-selection="p"
                      icon-name="brand-syringe"
                      heading-text="Surgical centers"
                      @click="changeView('hospital:2')"
                    />
                  </div>
                </hp5-container>
              </div>
            </div>
          </div>
        </hp5-page-content-container>
        <hp5-spacing-vertical xs="lg" sm="lg" md="lg" lg="lg" />
      </hp5-background>
      <hp5-spacing-vertical xs="xl" sm="xl" md="xl" lg="xl" />
    </div>
</template>
  
<script setup>
  
    const { profile, context, hideLandingPage, criteriaContext, plan } = useFCPModel()
    const { isDentalOnly, isMedicalOnly } = usePlan(profile, context)
    const showCompareCosts = computed(() => profile.value.shouldShowCostEstimates)
    const showDentalOnly = isDentalOnly()
    const showMedicalOnly = isMedicalOnly()

    function changeView(type) {
        context.value.type = type
        criteriaContext.value.type = type
        hideLandingPage.value = true
    }

</script>
  
<style scoped lang="scss">
@use '../../assets/scss/breakpoints' as *;
  #landing-page-main-container {
    font-family: var(--text-heading-font-xs);
    font-size: var(--text-heading-pixels-xs);
    line-height: var(--text-heading-line-height-xs);
    letter-spacing: var(--text-heading-letter-spacing-xs);
  }
  
  #main-heading, #plan-name {
    display: grid;
    justify-content: center;
  }
  @include small-up {
  }
  </style>
  
  <style lang="scss">
  hp5-expand-collapse .content.expanded {
    margin-top: 0;
  }
  hp5-expand-collapse .expand-collapse-button {
    font-weight: var(--text-body-weight-xs);
  }
</style>